<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">
        {{
          initialData?.title?.trim() || initialData?.buttonText?.trim()
            ? 'Edit Landing Page'
            : 'Create Landing Page'
        }}
      </h2>
      <button type="button" class="close-button" (click)="onClose()">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Form Section -->
      <div class="form-section">
        <div class="form-group-block">
          <h3 class="group-title">Brand</h3>
          <label class="form-label">Logo<span class="required">*</span></label>
          <div
            class="file-upload-container"
            [class.error]="validationErrors.logo || fileValidationError"
          >
            <div class="file-upload-area" *ngIf="!logoFile && !formData.logo">
              <input
                type="file"
                id="landing-logo-upload"
                accept=".png,.jpg,.jpeg,image/png,image/jpeg,image/jpg"
                class="file-input"
                (change)="onLogoUpload($event)"
              />
              <label class="file-upload-label" for="landing-logo-upload">
                <div class="upload-icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
                      stroke="#15172E"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.1666 6.66667L9.99992 2.5L5.83325 6.66667"
                      stroke="#15172E"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 2.5V12.5"
                      stroke="#15172E"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span class="upload-text"
                  >Drag &amp; drop your files here or <strong>browse</strong> to upload</span
                >
                <span class="upload-info"
                  >.png, .jpg, .jpeg Max file size - 2MB, Max dimensions -
                  {{ maxLogoDimensions.width }}x{{ maxLogoDimensions.height }}px</span
                >
              </label>
            </div>

            <div class="file-uploaded" *ngIf="logoFile || formData.logo">
              <div class="uploaded-file">
                <div class="success-icon" *ngIf="!isUploadingLogo">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <circle cx="8" cy="8" r="6" fill="#079271" />
                    <path
                      d="M5.5 8L7 9.5L10.5 6"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="loading-spinner-icon" *ngIf="isUploadingLogo">
                  <div class="spinner"></div>
                </div>
                <span class="file-name">{{ logoFile?.name || logoFileName }}</span>
                <button
                  type="button"
                  class="remove-file"
                  (click)="removeLogo()"
                  [disabled]="isUploadingLogo"
                  aria-label="Remove logo"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M9 3L3 9M3 3L9 9"
                      stroke="#A7ABB3"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="error-message" *ngIf="validationErrors.logo">{{ validationErrors.logo }}</div>
          <div class="error-message" *ngIf="fileValidationError">{{ fileValidationError }}</div>
          <label class="form-label form-label-title-top-margin" for="landing-title"
            >Title<span class="required">*</span></label
          >
          <input
            id="landing-title"
            class="form-input overflow-hidden"
            [class.error]="validationErrors.title"
            [(ngModel)]="formData.title"
            maxlength="100"
            (input)="onTitleChange()"
          />
          <div class="error-message" *ngIf="validationErrors.title">
            {{ validationErrors.title }}
          </div>
          <label class="form-label" for="landing-subtitle">Subtitle</label>
          <input
            id="landing-subtitle"
            class="form-input overflow-hidden"
            [(ngModel)]="formData.subtitle"
            maxlength="200"
          />
        </div>

        <div class="form-group-block">
          <h3 class="group-title">Form Input</h3>
          <label class="form-label" for="input-label">Label</label>
          <input id="input-label" class="form-input" [(ngModel)]="formData.inputLabel" />
          <label class="form-label" for="input-type">Type</label>
          <select
            id="input-type"
            class="form-input"
            [(ngModel)]="formData.inputType"
            (ngModelChange)="onInputTypeChange()"
          >
            <option value="Phone">Phone</option>
            <option value="Email">Email</option>
          </select>
        </div>

        <div class="form-group-block">
          <h3 class="group-title">Validation</h3>

          <div class="validation-rule" *ngIf="isEmailInputType">
            <div class="toggle-row validation-toggle-row">
              <span>Validate email</span>
              <label class="toggle-switch" [class.on]="formData.validateEmail">
                <input
                  type="checkbox"
                  class="toggle-switch-input"
                  [(ngModel)]="formData.validateEmail"
                  aria-label="Validate email"
                />
                <span class="toggle-switch-track" aria-hidden="true">
                  <span class="toggle-switch-knob"></span>
                </span>
              </label>
            </div>
            <div class="validation-rule-panel" *ngIf="formData.validateEmail">
              <label class="form-label validation-panel-label" for="email-error-message">
                Error message<span class="required">*</span>
              </label>
              <input
                id="email-error-message"
                class="form-input validation-panel-input"
                [class.error]="validationErrors.validateEmailErrorMessage"
                [(ngModel)]="formData.validateEmailErrorMessage"
                (input)="onValidateEmailErrorMessageChange()"
              />
              <div class="error-message" *ngIf="validationErrors.validateEmailErrorMessage">
                {{ validationErrors.validateEmailErrorMessage }}
              </div>
            </div>
          </div>

          <div class="validation-rule" *ngIf="!isEmailInputType">
            <div class="toggle-row validation-toggle-row">
              <span>Validate US phone number</span>
              <label class="toggle-switch" [class.on]="formData.validatePhone">
                <input
                  type="checkbox"
                  class="toggle-switch-input"
                  [(ngModel)]="formData.validatePhone"
                  aria-label="Validate US phone number"
                />
                <span class="toggle-switch-track" aria-hidden="true">
                  <span class="toggle-switch-knob"></span>
                </span>
              </label>
            </div>
            <div class="validation-rule-panel" *ngIf="formData.validatePhone">
              <label class="form-label validation-panel-label" for="us-phone-error-message">
                Error message<span class="required">*</span>
              </label>
              <input
                id="us-phone-error-message"
                class="form-input-button-text validation-panel-input"
                [class.error]="validationErrors.validatePhoneErrorMessage"
                [(ngModel)]="formData.validatePhoneErrorMessage"
                (input)="onValidatePhoneErrorMessageChange()"
              />
              <div class="error-message" *ngIf="validationErrors.validatePhoneErrorMessage">
                {{ validationErrors.validatePhoneErrorMessage }}
              </div>
            </div>
          </div>

          <div class="validation-rule" *ngIf="!isEmailInputType">
            <div class="toggle-row validation-toggle-row">
              <span>Digit Validation</span>
              <label class="toggle-switch" [class.on]="formData.validateDigits">
                <input
                  type="checkbox"
                  class="toggle-switch-input"
                  [(ngModel)]="formData.validateDigits"
                  aria-label="Digit Validation"
                />
                <span class="toggle-switch-track" aria-hidden="true">
                  <span class="toggle-switch-knob"></span>
                </span>
              </label>
            </div>
            <div class="validation-rule-panel" *ngIf="formData.validateDigits">
              <label class="form-label validation-panel-label" for="digit-length">
                Number of digits<span class="required">*</span>
              </label>
              <input
                id="digit-length"
                type="number"
                min="1"
                class="form-input-button-text validation-panel-input"
                [class.error]="validationErrors.digitLength"
                [(ngModel)]="formData.digitLength"
                (input)="onDigitLengthChange()"
              />
              <div class="error-message" *ngIf="validationErrors.digitLength">
                {{ validationErrors.digitLength }}
              </div>
              <label class="form-label validation-panel-label" for="digits-error-message">
                Error message<span class="required">*</span>
              </label>
              <input
                id="digits-error-message"
                class="form-input-button-text validation-panel-input"
                [class.error]="validationErrors.validateDigitsErrorMessage"
                [(ngModel)]="formData.validateDigitsErrorMessage"
                (input)="onValidateDigitsErrorMessageChange()"
              />
              <div class="error-message" *ngIf="validationErrors.validateDigitsErrorMessage">
                {{ validationErrors.validateDigitsErrorMessage }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-group-block">
          <h3 class="group-title">Button</h3>
          <label class="button-text-label" for="button-text"
            >Add the button text here<span class="required">*</span></label
          >
          <input
            id="button-text"
            class="form-input-button-text"
            [class.error]="validationErrors.buttonText"
            [(ngModel)]="formData.buttonText"
            maxlength="30"
            (input)="onButtonTextChange()"
          />
          <div class="error-message" *ngIf="validationErrors.buttonText">
            {{ validationErrors.buttonText }}
          </div>
          <p class="form-label button-color-label">Button Color<span class="required">*</span></p>
          <div class="color-grid">
            <button
              *ngFor="let color of buttonColors"
              type="button"
              class="color-dot"
              [style.backgroundColor]="color"
              [class.selected]="formData.buttonColor === color"
              [attr.aria-label]="'Select color ' + color"
              (click)="onColorSelect(color)"
            ></button>
          </div>
        </div>

        <div class="form-group-block">
          <h3 class="group-title">Consent</h3>
          <div class="toggle-row">
            <span>Show consent block</span>
            <label class="toggle-switch" [class.on]="formData.showConsentBlock">
              <input
                type="checkbox"
                class="toggle-switch-input"
                [(ngModel)]="formData.showConsentBlock"
                aria-label="Show consent block"
              />
              <span class="toggle-switch-track" aria-hidden="true">
                <span class="toggle-switch-knob"></span>
              </span>
            </label>
          </div>
          <ng-container *ngIf="formData.showConsentBlock">
            <label class="form-label-consent-text" for="consent-text">Consent text</label>
            <textarea
              id="consent-text"
              class="form-input-second form-textarea"
              [(ngModel)]="formData.consentText"
            ></textarea>
            <p class="consent-field-hint">wrap link slots in &#123;curly braces&#125;</p>
            <label class="form-label" for="consent-label">Label</label>
            <input
              id="consent-label"
              class="form-input-second"
              [(ngModel)]="formData.consentLabel"
              (ngModelChange)="onConsentLabelChange($event)"
            />
            <label class="form-label" for="consent-url">URL</label>
            <input id="consent-url" class="form-input-second" [(ngModel)]="formData.consentUrl" />
          </ng-container>
        </div>
      </div>

      <!-- Preview Section -->
      <div class="preview-section">
        <div class="preview-toolbar">
          <div class="preview-toggle" role="group" aria-label="Preview mode toggle">
            <button
              type="button"
              class="preview-toggle-btn"
              [class.active]="previewMode === 'desktop'"
              (click)="setPreviewMode('desktop')"
              aria-label="Desktop preview"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 13H11.75M5.75 10V13M10.25 10V13M1.25 1.75C1.25 1.55109 1.32902 1.36032 1.46967 1.21967C1.61032 1.07902 1.80109 1 2 1H14C14.1989 1 14.3897 1.07902 14.5303 1.21967C14.671 1.36032 14.75 1.55109 14.75 1.75V9.25C14.75 9.44891 14.671 9.63968 14.5303 9.78033C14.3897 9.92098 14.1989 10 14 10H2C1.80109 10 1.61032 9.92098 1.46967 9.78033C1.32902 9.63968 1.25 9.44891 1.25 9.25V1.75Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button
              type="button"
              class="preview-toggle-btn"
              [class.active]="previewMode === 'mobile'"
              (click)="setPreviewMode('mobile')"
              aria-label="Mobile preview"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 2H6.75M6 11.75V11.7575M1.5 2.75C1.5 2.35218 1.65804 1.97064 1.93934 1.68934C2.22064 1.40804 2.60218 1.25 3 1.25H9C9.39782 1.25 9.77936 1.40804 10.0607 1.68934C10.342 1.97064 10.5 2.35218 10.5 2.75V13.25C10.5 13.6478 10.342 14.0294 10.0607 14.3107C9.77936 14.592 9.39782 14.75 9 14.75H3C2.60218 14.75 2.22064 14.592 1.93934 14.3107C1.65804 14.0294 1.5 13.6478 1.5 13.25V2.75Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="preview-card" [class.mobile-preview]="previewMode === 'mobile'">
          <div class="preview-card-top">
            <button
              *ngIf="showViewInBrowserLink"
              type="button"
              class="view-link"
              (click)="onViewInBrowser()"
            >
              View in browser →
            </button>
          </div>
          <div class="preview-logo" [class.has-image]="!!logoPreviewUrl">
            <img *ngIf="logoPreviewUrl" [src]="logoPreviewUrl" alt="Logo preview" />
            <span *ngIf="!logoPreviewUrl">Logo</span>
          </div>
          <div class="preview-card-content">
            <h4 class="preview-title">{{ formData.title || placeholders.title }}</h4>
            <p class="preview-subtitle">
              {{ formData.subtitle || placeholders.subtitle }} — drop your number to claim.
            </p>
            <label class="preview-input-label"
              >{{ formData.inputLabel || (isEmailInputType ? 'Email' : placeholders.inputLabel)
              }}<span class="required">*</span></label
            >
            <button
              type="button"
              class="preview-button"
              [style.backgroundColor]="formData.buttonColor"
            >
              {{ formData.buttonText || placeholders.buttonText }}
            </button>
          </div>
          <div class="preview-consent-container">
            <p class="preview-consent" *ngIf="formData.showConsentBlock">
              <ng-container *ngFor="let segment of getConsentPreviewSegments()">
                <ng-container *ngIf="segment.type === 'text'">{{ segment.value }}</ng-container>
                <a
                  *ngIf="segment.type === 'link'"
                  class="preview-consent-link"
                  [href]="segment.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ segment.value }}</a
                >
              </ng-container>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onReset()">Reset</button>
      <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
    </div>
  </div>
</div>
